<template>
<div class="main my">
  <!-- 教练管理 -->
  <div class="model-box bcg crw clear mbn" @click="scanCode()">
    <h4 class="left"><i class="my-model__icon iconfont">&#xe660;</i> 邀请教练加入</h4>
    <span class="right fs2 crw"><van-icon name="arrow" class="vam"/></span>
  </div>
  <div class="bcw">
    <van-cell v-for="(item,index) in list" :key="index" :title="item.realName" is-link :center="true"  :label="item.title | titleFilter" :to="'mcoachedit?coachId='+item.coachId" />

    <div v-if="list.length==0" v-show="none" class="tac c9 fs2 ptm pbm">~ 暂无记录 ~</div>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import wx from "weixin-js-sdk";
import weChat from "@/assets/scripts/wechat";
import {
  Cell, CellGroup
} from 'vant';
Vue.use(Cell).use(CellGroup);



export default {
  components: {
  },
  filters: {
    titleFilter(status) {
      // 教练职称
      const statusMap = {
        assistant: '助教',
        junior: '初级教练',
        intermediate: '中级教练',
        senior: '高级教练'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list:[],
      listTotal:'', //列表总数
      none:false,
    }
  },
  created(){
    this.fetchData()
  },
  methods: {
    fetchData(more) {
      // 获取列表
      this.$http.post('club_coach_manage/getList').then(res => {
        if (!res.data.code) {
          this.list = res.data.value
          this.listTotal = res.data.value.length
        } else {
          Toast.fail(res.data.message);
        }
        this.none = true //解决“暂无记录”默认显示的问题
      })
    },
    scanCode() {
      let _this = this
      weChat.wxConfig().then(() => {
        // 扫一扫
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            //console.log(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
            // alert(res.resultStr)
            // 跳转到添加页面
            _this.$router.push({path: 'mcoachadd',query:{'userId':res.resultStr}})
          }
        });
      });
    },
  }
}
</script>
<style lang="less" scoped>
.my-model{
  padding: .1rem 0; 
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/CoachList.vue